import { ManualDasConfigurationSwitchEntityToDto } from "src/app/features/ManualDasConfiguration/services/mappers/ManualDasConfigurationSwitchEntityToDto";
import type { ManualDasConfigurationSwitchEntity } from "src/app/features/ManualDasConfiguration/types/ManualDasConfigurationSwitchEntity";
import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";

const ManualDasConfigurationApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        ManualDasConfigurationSwitchUpdate: builder.mutation<
            ManualDasConfigurationSwitchEntity,
            FormMutation<ManualDasConfigurationSwitchEntity>
        >({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.MANUAL_DAS_CONFIGURATION}/switch-acquirer`;
                const method = "PUT";

                const body = ManualDasConfigurationSwitchEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.MANUAL_DAS_CONFIGURATION],
        }),
    }),
});

export const { useManualDasConfigurationSwitchUpdateMutation } = ManualDasConfigurationApi;
